import { useCallback } from 'react';
import { faro } from '../config/faro';
import { trackAmplitudeEvent } from '../config/amplitude';

export function useAnalytics() {
  const trackFeatureUsed = useCallback(
    (feature: string, details?: Record<string, string>) => {
      faro?.api.startUserAction(feature, details);
      trackAmplitudeEvent(feature, details);
    },
    [],
  );

  const trackButtonClick = useCallback(
    (button: string, context?: string) => {
      faro?.api.startUserAction(button, { ...(context ? { context } : {}) });
      trackAmplitudeEvent(button, context ? { context } : undefined);
    },
    [],
  );

  return { trackFeatureUsed, trackButtonClick };
}
